import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, Flex, Text, getPaletteColor } from 'pcln-design-system'
import { ChevronUp, ChevronDown } from 'pcln-icons'

const propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  filterCatagory: PropTypes.string,
  isExpanded: PropTypes.bool.isRequired,
  textCollapsed: PropTypes.string,
  textExpanded: PropTypes.string,
  showChip: PropTypes.bool,
}

const defaultProps = {
  className: '',
  onClick: null,
  filterCatagory: '',
  textCollapsed: '',
  textExpanded: '',
  showChip: false,
}

const ExpanderWrap = styled(Button)`
  display: flex;
  color: ${getPaletteColor('base')};
  &:hover {
    text-decoration: none;
  }
  ${(props) =>
    props.showChip
      ? `border-radius: ${props.theme.borderRadii.xl};
     padding: ${props.theme.space[2]}px;
     font-weight: ${props.theme.fontWeights.bold};
     width: auto;
     background-color: ${getPaletteColor('background.base')(props)}
    `
      : `background-color: transparent;
     width: 100%;
     
     `}
`

const sentenceCase = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word, index) => (index === 0 ? word.replace(word[0], word[0].toUpperCase()) : word))
    .join(' ')
}

const Expander = ({
  className,
  onClick,
  filterCatagory,
  isExpanded,
  textCollapsed,
  textExpanded,
  showChip,
}) => {
  const linkText = (
    <Text fontSize={1} align='initial'>
      {isExpanded ? sentenceCase(textExpanded) : sentenceCase(textCollapsed)}
      &nbsp;
      {filterCatagory.toLowerCase()}
    </Text>
  )

  const buttonText = (
    <Text fontSize={0} mx={1}>
      {isExpanded ? textExpanded : textCollapsed}
      &nbsp;
      {filterCatagory}
    </Text>
  )
  return (
    <Flex justifyContent={showChip ? 'center' : ''} mt={showChip ? 3 : 0}>
      <ExpanderWrap
        variation='link'
        align='center'
        alignItems='center'
        className={className}
        onClick={onClick}
        color='primary'
        data-testid='EXPANDER'
        showChip={showChip}
      >
        {!showChip ? linkText : buttonText}
        {isExpanded ? (
          <ChevronUp size={showChip ? 16 : 24} ml={1} />
        ) : (
          <ChevronDown size={showChip ? 16 : 24} ml={1} />
        )}
      </ExpanderWrap>
    </Flex>
  )
}

Expander.propTypes = propTypes
Expander.defaultProps = defaultProps

export default Expander
